// Spread onto an element to block the casual "select text, Ctrl+C" path.
// This is friction, not real protection — the text is still in the page
// source and the API response, so anyone using dev tools or view-source
// can get it regardless. It just stops the easy case.
function preventDefault(e) {
  e.preventDefault();
}

export const noCopyHandlers = {
  onCopy: preventDefault,
  onCut: preventDefault,
  onContextMenu: preventDefault,
  onDragStart: preventDefault,
};
